import { createSlice } from "@reduxjs/toolkit";

const defaultAnalysisState = {
  showBlurredImages: true,
  analysisOptions: {
    showBoxes: {
      selected: true
    },
    blurryImages: {
      selected: true
    },
    snapshot: {
      selected: false
    },
    imageInfo: {
      selected: true
    },
    AI: {
      selected: true
    },
    HI: {
      selected: false
    },
    annotation: {
      selected: false
    }
  },
  blurredImagesList: [],
  activeAnalysisTab: "linearAnalysis",
  drillDownAnalysis: {
    selectedBrand: [],
    selectedVariant: [],
    selectedSku: [],
    currentSelectedType: "",
    brandOptions: [],
    variantOptions: [],
    skuOptions: [],
    colors: {}
  },
  linearAnalysis: {
    selectedBrands: [],
    selectedVariants: [],
    selectedSkus: [],
    currentSelectedType: "",
    colors: {}
  },
  annotationOptions: {
    common: {
      selected: false,
      value: 0,
      color: "rgba(0, 255, 179, 0.5)"
    },
    falsePositive: {
      selected: false,
      value: 0,
      color: "rgba(255, 0, 27, 0.5)"
    },
    falseNegative: {
      selected: false,
      value: 0,
      color: "rgba(248, 231, 28, 0.5)"
    }
  }
}

export const analysisSlice = createSlice({
  name: "analysis",
  initialState: {
    ...defaultAnalysisState
  },
  reducers: {
    toggleBlurredImages(state, action) {
      state.showBlurredImages = action.payload;
    },
    updatedBlurredImageList(state, action) {
      state.blurredImagesList = action.payload;
    },
    toggleAnalysisOptions(state, action) {
      const { type, value } = action.payload;
      state["analysisOptions"][type]["selected"] = value;
    },
    changeAnnotationOptions(state, action) {
      const { type, property, value } = action.payload;
      state["annotationOptions"][type][property] = value;
    },
    updateOptions(state, action) {
      const { analysis, type, value, currentSelectedType } = action.payload;
      state[analysis][type] = value;
      state[analysis]["currentSelectedType"] = currentSelectedType
    },
    removeOption(state, action) {
      const { analysis, value, currentSelectedType, colors } = action.payload;
      state[analysis][currentSelectedType] = value;
      state[analysis]["colors"] = colors;
    },
    changeColor(state, action) {
      const { analysis, value } = action.payload;
      state[analysis]["colors"] = value;
    },
    changeActiveTab(state, action) {
      state.activeAnalysisTab = action.payload;
    },
    resetStateByType(state, action) {
      const { type, updatedState } = action.payload;
      state[type] = updatedState;
    },
    resetAnalysisStateToDefault(state, action) {
      const updatedState = { ...state, ...defaultAnalysisState };
      return updatedState
    },
    setVariantDrilldown(state, action) {
      const { analysis, value, variantOptions, currentSelectedType } = action.payload;
      state[analysis]["selectedBrand"] = value;
      state[analysis]["variantOptions"] = variantOptions;
      state[analysis]["currentSelectedType"] = currentSelectedType;
    },
    setSkuDrilldown(state, action) {
      const { analysis, value, skuOptions, currentSelectedType } = action.payload;
      state[analysis]["selectedVariant"] = value;
      state[analysis]["skuOptions"] = skuOptions;
      state[analysis]["currentSelectedType"] = currentSelectedType;
    },
    setSku(state, action) {
      const { analysis, value, currentSelectedType } = action.payload;
      state[analysis]["selectedSku"] = value;
      state[analysis]["currentSelectedType"] = currentSelectedType;
    }
  }
})